<div class="partner-product-card">
  @if (product.file) {
    <img [src]="imagesUrl + '/partner_products/' + product.file"
      class="partner-product-img" alt="" />
  }
  <div class="partner-product-info">
    <div class="partner-product-name">{{ product.name }}</div>
    <div class="partner-product-meta">
      @if (product.score) {
        <span class="partner-product-score">
          <strong>{{ product.score }} pkt.</strong>
        </span>
      }
      @if (false && product.valid) {
        <span class="partner-product-valid">
          <mat-icon>event</mat-icon> <div>Ważne do:</div> <strong>{{ product.valid | date:'dd.MM.yyyy' }}</strong>
        </span>
      }
    </div>
  </div>
</div>
